import { render, staticRenderFns } from "./WidgetContacts.vue?vue&type=template&id=aaded8c4&scoped=true&"
import script from "./WidgetContacts.vue?vue&type=script&lang=js&"
export * from "./WidgetContacts.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContacts.vue?vue&type=style&index=0&id=aaded8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaded8c4",
  null
  
)

export default component.exports